export const WAGMI_STORE_KEY = "wagmi.store";

/**
 * True when wagmi has a persisted connector session in localStorage.
 * Clearing site data / localStorage removes this even if the wallet extension
 * or a WalletConnect IndexedDB pairing is still authorized.
 */
export function hasPersistedWagmiSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem(WAGMI_STORE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as {
      state?: {
        current?: string | null;
        connections?: { __type?: string; value?: unknown[] } | Map<string, unknown>;
      };
    };
    const state = parsed?.state;
    if (!state?.current) return false;
    const connections = state.connections;
    if (connections instanceof Map) return connections.size > 0;
    if (connections?.__type === "Map") {
      return Array.isArray(connections.value) && connections.value.length > 0;
    }
    return false;
  } catch {
    return false;
  }
}

/** Full-page Connecting spinner while restoring a saved session or finishing a user connect. */
export function isWalletSessionPending(params: {
  hadPersistedSession: boolean;
  restoreTimedOut: boolean;
  connectInitiated: boolean;
  wagmiStatus: string | undefined;
}): boolean {
  const isRestoringPersistedSession =
    params.hadPersistedSession
    && !params.restoreTimedOut
    && (params.wagmiStatus === "reconnecting" || params.wagmiStatus === "connecting");
  const isAwaitingUserConnect = params.connectInitiated && params.wagmiStatus === "connecting";
  return isRestoringPersistedSession || isAwaitingUserConnect;
}

const PENDING_CHAIN_SWITCH_KEY = "pendingChainSwitch";

/** Drop a leftover chain-switch gate when the wagmi session was wiped. */
export function readPendingChainSwitch(hadPersistedSession: boolean): string | null {
  if (typeof window === "undefined") return null;
  if (!hadPersistedSession) {
    sessionStorage.removeItem(PENDING_CHAIN_SWITCH_KEY);
    return null;
  }
  return sessionStorage.getItem(PENDING_CHAIN_SWITCH_KEY);
}

